import type { RouteRecordRaw } from 'vue-router';
import core from './modules/core/router/routes';
import authRoutes from '@common/lib/modules/auth/routes/routes';
// import positionRoutes from './modules/master-data/position/routes/routes';
// import specialityRoutes from './modules/master-data/speciality/routes/routes';
// import educationTypeRoutes from './modules/master-data/education-type/routes/routes';
// import countryRoutes from './modules/master-data/country/routes/routes';
// import reasonForAbsenceRoutes from './modules/master-data/reason-for-absence/routes/routes';
// import amountRoutes from './modules/master-data/amount/routes/routes';
// import instructorStatusRoutes from './modules/master-data/instructor-status/routes/routes';
// import educationFormRoutes from './modules/master-data/education-form/routes/routes';
// import courseRoutes from './modules/master-data/course/routes/routes';
// import hospitalRoutes from './modules/master-data/hospital/routes/routes';
// import educationLocationRoutes from './modules/master-data/education-location/routes/routes';
// import workMonthRoutes from './modules/master-data/work-month/routes/routes';
import masterDataRoutes from './modules/master-data/routes/routes';
import personRoutes from './modules/person/routes/routes';
import monthlyDataEntryRoutes from './modules/monthly-data-entry/routes/routes';
import postGraduateEducationTemplateRoutes from './modules/post-graduate-education-template/routes/routes';
import adminRoutes from './modules/admin/routes/routes';
import dashboard from './modules/dashboard/routes/routes';
import transactionData from './modules/transaction-data/routes/routes';
import loginTransactionData from './modules/login-transaction-data/routes/routes';
import exportRoutes from './modules/export/routes/routes';

const routes: RouteRecordRaw[] = [
  {
    path: '/',
    children: [
      {
        path: '',
        component: () => import('./components/layouts/MainLayout.vue'),
        children: [
          ...core,
          ...dashboard,
          ...adminRoutes,
          ...transactionData,
          ...loginTransactionData,
          ...exportRoutes,
          // ...positionRoutes,
          // ...specialityRoutes,
          // ...educationTypeRoutes,
          // ...countryRoutes,
          // ...reasonForAbsenceRoutes,
          // ...amountRoutes,
          // ...instructorStatusRoutes,
          // ...educationFormRoutes,
          // ...courseRoutes,
          ...personRoutes,
          // ...hospitalRoutes,
          // ...educationLocationRoutes,
          // ...workMonthRoutes,
          ...postGraduateEducationTemplateRoutes,
          ...masterDataRoutes,
          ...monthlyDataEntryRoutes,
          ...authRoutes.mainRoutes
        ]
      },
      {
        path: '',
        component: () => import('./components/layouts/LoginLayout.vue'),
        children: [...authRoutes.routes]
      }
    ]
  },
  {
    path: '/:pathMatch(.*)*',
    component: () => import('./modules/core/pages/ErrorPage.vue')
  }
];

export default routes;
